import { useContext } from 'react'
import { useSelector } from 'react-redux'
import { Box } from 'grommet/es6/components/Box'
import { ResponsiveContext } from 'grommet/es6/contexts/ResponsiveContext'
import { selectHasAccounts } from 'app/state/wallet/selectors'
import { MobileFooterNavigation } from '../MobileFooterNavigation'

export const PageFooter = () => {
  const isMobile = useContext(ResponsiveContext) === 'small'
  const walletHasAccounts = useSelector(selectHasAccounts)

  if (walletHasAccounts && isMobile) {
    return (
      <Box pad="xlarge">
        <MobileFooterNavigation />
      </Box>
    )
  }
  return null
}
